import { useEffect } from "react";
import { useLang } from "../hooks/useLang";

// PaymentResult — /payment/success ve /payment/error landing sayfası.
// Popup olarak açılır; opener'a (Yönetim > Abonelik) haber verip kapanır.
export default function PaymentResult() {
  const { t } = useLang();
  const params = new URLSearchParams(window.location.search);
  const isSuccess =
    window.location.pathname.startsWith("/payment/success") && params.get("status") !== "error";
  const orderid = params.get("orderid") || "";
  const rawError = (params.get("message") || params.get("errmsg") || "").trim();

  // Ödeme sağlayıcısının hata kodu müşteriye HAM gösterilmez — bir müşteri
  // "garanti_not_configured" gördü (2026-07-29). Bilinen kodlar anlaşılır metne
  // çevrilir; bilinmeyen kod genel mesaja düşer. Ham kod kaybolmaz: aşağıda
  // "Destek referansı" satırında kalır, destek onunla teşhis eder.
  // Kod listesi: docs/GARANTI_RELAY_ENTEGRASYON.md §2 ve §7 (Garanti),
  // go/internal/api/handler/payment.go settlePayPal (PayPal).
  const errorText = (() => {
    if (!rawError) return t("pay_fail_body");
    if (/^md_\d+$/.test(rawError)) return t("pay_err_3d");
    switch (rawError) {
      case "amount_mismatch":
      case "currency_mismatch":
      case "amount_or_currency_mismatch":
        return t("pay_err_amount");
      // Bizim/sağlayıcının yapılandırma hataları — müşterinin yapabileceği bir şey yok.
      case "garanti_not_configured":
      case "reseller_not_found":
      case "invalid_token":
      case "relay_not_found":
      case "paypal_not_configured":
      case "paypal_error":
      case "order_not_found":
        return t("pay_err_provider");
      // PayPal: ödeme yarıda bırakıldı ya da PayPal tahsilatı reddetti.
      // İkisi de müşterinin tekrar deneyebileceği durumdur.
      case "paypal_cancelled":
        return t("pay_err_cancelled");
      case "paypal_declined":
        return t("pay_err_declined");
      default:
        return t("pay_fail_body");
    }
  })();

  useEffect(() => {
    try { window.opener?.postMessage("payment:done", "*"); } catch { /* ignore */ }
    const timer = setTimeout(() => { if (window.opener) window.close(); }, 2500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, background: "var(--shell-bg)" }}>
      <div className="answer-card" style={{ maxWidth: 420, textAlign: "center" }}>
        <span
          className={"badge " + (isSuccess ? "ok" : "off")}
          style={{ fontSize: 13, padding: "6px 14px" }}
        >
          {isSuccess ? t("pay_success_tag") : t("pay_fail_tag")}
        </span>
        <h2 style={{ margin: "14px 0 6px" }}>{isSuccess ? t("pay_success_title") : t("pay_fail_title")}</h2>
        <p className="hint">{isSuccess ? t("pay_success_body") : errorText}</p>
        {orderid && <p className="hint" style={{ fontSize: 12 }}>{t("pay_order")}: {orderid}</p>}
        {!isSuccess && rawError && (
          <p className="hint" style={{ fontSize: 12, opacity: 0.75 }}>
            {t("pay_err_ref")}: <code>{rawError}</code>
          </p>
        )}
        <a href="/" className="btn-pri" style={{ display: "inline-block", marginTop: 14 }}>{t("pay_back")}</a>
      </div>
    </div>
  );
}
